module.exports = __webpack_public_path__ + "img/4.e76a80bd.png";